import React from 'react';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

interface FormFieldProps {
  label: string;
  required?: boolean;
  optional?: boolean;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

/** Label-above-input wrapper. Wraps the control in a <label> so clicking the text focuses it. */
const FormField: React.FC<FormFieldProps> = ({ label, required, optional, children, sx }) => (
  <Box component="label" sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, minWidth: 0, ...(sx as object) }}>
    <Box component="span" sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary' }}>
      {label}
      {required && (
        <Box component="span" aria-hidden sx={{ color: 'error.main' }}>
          {' *'}
        </Box>
      )}
      {optional && (
        <Box component="span" sx={{ fontWeight: 400, ml: 0.5, opacity: 0.8 }}>
          optional
        </Box>
      )}
    </Box>
    {children}
  </Box>
);

export default FormField;
